import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "hstack gap-2 align-end" }
const _hoisted_5 = ["disabled", "aria-disabled"]
const _hoisted_6 = ["disabled", "aria-disabled"]

import {computed, ref, watch} from "vue";
import BFilterEditor from "./BFilterEditor.vue";
import {BFilter, BFilterOptions, BFilterableField, describeFilters} from "./BFilterEditor.types";
import {deepCopy} from "@/utils";
import InformationModal from "../Misc/InformationModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BFilterModal',
  props: /*@__PURE__*/_mergeModels({
    filterOptions: { default: () =>
            ({
                filters: [],
            } as BFilterOptions) },
    filterableFields: { default: () => [] }
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["filterChanged"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel(__props, "modelValue");

const props = __props;

const emit = __emit;


const isApplyFilterDisabled = computed(() => {
     return !filterInfo.value.filters.every(
        (it) => it.property != null && it.operation != null && it.value && it.property != "id"
    );
});
const hasAppliedFilters = computed(() => filterInfo.value.filters.length > 0);


var filterInfo = ref(deepCopy<BFilterOptions>(props.filterOptions));

const handleDataChange = (value: BFilterOptions) => {
    filterInfo.value = value;
};

watch(model, (newValue) => {
    if (newValue === true) {
        filterInfo.value = deepCopy<BFilterOptions>(props.filterOptions);
    }
});

watch(
    () => props.filterOptions,
    (newfilterOptions, prevFilterOptions) => {
        if (filterInfo.value != props.filterOptions) {
            filterInfo.value = props.filterOptions
                ? deepCopy<BFilterOptions>(props.filterOptions)
                : ({filters: {}} as BFilterOptions);                
        }
    }
);
function resetFilters() {
    filterInfo.value.filters = [];
    emit("filterChanged", filterInfo.value);
}

function applyFilters() {    
    emit("filterChanged", filterInfo.value);
}

function addFilter() {
    var newFilter = {
        property: null,
        operation: null,
        value: null,
    } as BFilter;

    if (filterInfo.value) {
        filterInfo.value.filters = [...filterInfo.value.filters, newFilter];
    }
}

function removeFilter(index: number) {
    if (filterInfo.value) {
        filterInfo.value.filters = filterInfo.value.filters.filter((it: any, ix: number) => ix != index);
    }
}

function updateFilter(data: any) {
    if (data?.index > 0 && data?.filter != undefined) {
        filterInfo.value.filters[data.index] = data.filter;
    }   
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InformationModal, {
    title: "Filter Options",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    "show-footer": true,
    width: "50.5em",
    "modal-body-container-class": "overflow-visible-y"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BFilterEditor, {
          modelValue: _unref(filterInfo),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterInfo) ? (filterInfo).value = $event : filterInfo = $event)),
          ref: "filterEditor",
          value: _unref(filterInfo),
          fields: _ctx.filterableFields,
          onAddFilter: addFilter,
          onRemoveFilter: removeFilter,
          onUpdateFilter: updateFilter
        }, null, 8, ["modelValue", "value", "fields"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn btn-primary", {disabled: isApplyFilterDisabled.value}]),
              disabled: isApplyFilterDisabled.value,
              "aria-disabled": isApplyFilterDisabled.value,
              onClick: _withModifiers(applyFilters, ["prevent"])
            }, " Apply Filter ", 10, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn btn-danger", {disabled: !hasAppliedFilters.value}]),
              disabled: !hasAppliedFilters.value,
              "aria-disabled": !hasAppliedFilters.value,
              onClick: _withModifiers(resetFilters, ["prevent"])
            }, " Clear Filter ", 10, _hoisted_6)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})